import React, { Fragment, ReactElement, useEffect, useState } from "react"
import { RouteComponentProps, Link } from "@reach/router"
import { useGetExperienceByName } from "../../Hooks"
// import { onCreateEvent } from "../../graphql/subscriptions"
import defaultPic from "../../../assets/icons/abstract-user-flat-4.svg"
import { InlineShareButtons } from "sharethis-reactjs"
import durationIcon from "../../../assets/icons/duration.svg"
import locationIcon from "../../../assets/icons/location.svg"
import objectivesIcon from "../../../assets/icons/objectives.svg"
import infoIcon from "../../../assets/icons/info.svg"
import bringIcon from "../../../assets/icons/bring.svg"
import providedIcon from "../../../assets/icons/provided.svg"
import giftIcon from "../../../assets/icons/gift.svg"
import sessionIcon from "../../../assets/icons/sessions.svg"
import groupIcon from "../../../assets/icons/group.svg"
import priceIcon from "../../../assets/icons/price.svg"
import lionsIcon from "../../../assets/icons/lions.png"

import { Navigation, Spinner } from "../../components"
import { getTimeFromMin } from "../../lib"
import styles from "./Experience.scss"
import { sendPageTrackingEvent } from "../../services"
import mockedExperiences from "../../mockedExperiences"

interface IProps {
  name: string
}

const renderInfo = (str: string) => <p>{str}</p>

const renderTitledInfo = (
  title: string,
  children: string | ReactElement,
  extraElement?: ReactElement
) => (
  <div id={title} className={styles.titledInfo}>
    <div>
      <h3>{title}</h3>
      <div>
        <div>{children}</div>
      </div>
    </div>
    {extraElement}
  </div>
)

const renderSession = (
  text,
  { duration, objectives, location, toBring, provided, offered, advice }
) => {
  return (
    <div key={text} id="session">
      <h3>{text}</h3>
      {renderIconedInfo(durationIcon, getTimeFromMin(duration), "Durée : ")}
      {renderIconedInfo(
        locationIcon,
        <div>
          {location}
          <div>
            {
              "(L'adresse exacte est notée sur votre confirmation de réservation)"
            }
          </div>
        </div>,
        "Où : "
      )}
      {!objectives.length ||
        renderIconedInfo(
          objectivesIcon,
          <div>
            {objectives.map((obj) => (
              <div key={obj.text}>
                <strong>{obj.verb}</strong>
                {obj.text}
              </div>
            ))}
          </div>,
          "Objectifs : "
        )}
      {!advice.length ||
        renderIconedInfo(
          infoIcon,
          <div>
            {advice.map((item) => (
              <div key={item}>{item}</div>
            ))}
          </div>,
          "Infos : "
        )}
      {!toBring.length ||
        renderIconedInfo(
          bringIcon,
          <div>
            {toBring.map((item) => (
              <div key={item}> {item}</div>
            ))}
          </div>,
          "À apporter : "
        )}
      {!provided.length ||
        renderIconedInfo(
          providedIcon,
          <div>
            {provided.map((item) => (
              <div key={item}>{item}</div>
            ))}
          </div>,
          "Fournis : "
        )}
      {!offered.length ||
        renderIconedInfo(
          giftIcon,
          <div>
            {offered.map((item) => (
              <div key={item}>{item}</div>
            ))}
          </div>,
          "Offert : "
        )}
    </div>
  )
}

const renderHostPic = ({ name, pic }) => {
  return (
    <span id="hostDescription">
      <div>
        <div>
          <img src={pic || defaultPic} />
        </div>
        {name}
      </div>
    </span>
  )
}

const renderIconedInfo = (iconPath: string, text: string, title?: string) => (
  <div id="iconed">
    <div>
      <img src={iconPath} alt={title} />
      {title !== "lions" && <div>{title}</div>}
    </div>
    <span>{text}</span>
  </div>
)

const renderDescription = (
  sessionsNumber: number,
  type: string,
  name: string,
  hostDescription: { text: string },
  { min, max },
  description: string,
  price: number,
  sessions
) => {
  function getProperDuration() {
    if (type === "koudpouce") {
      return `${sessionsNumber} x ${getTimeFromMin(
        sessions.map((s) => s.duration).reduce((curr, acc) => curr + acc)
      )} au total`
    }
    return `${getTimeFromMin(
      sessions.map((s) => s.duration).reduce((curr, acc) => curr + acc)
    )} au total`
  }

  function getProperSessionNumber() {
    if (type === "koudpouce") {
      return `${sessionsNumber} session${sessionsNumber > 1 ? "s" : ""}`
    }
    return `${sessions.length} session${sessions.length > 1 ? "s" : ""}`
  }

  return (
    <Fragment>
      <div>
        {renderInfo(name)}
        <div id="basics">
          {renderIconedInfo(durationIcon, getProperDuration())}
          {renderIconedInfo(priceIcon, `${price} euros`)}
          {renderIconedInfo(sessionIcon, getProperSessionNumber())}
          {renderIconedInfo(groupIcon, `Entre ${min} et ${max}`)}
          {renderIconedInfo(
            locationIcon,
            [...new Set(sessions.map((s) => s.location))].join("/")
          )}
        </div>
      </div>
      {renderTitledInfo(
        "À propos de votre spécialiste",
        hostDescription.text,
        renderHostPic(hostDescription)
      )}
      {renderTitledInfo("Au programme", description)}
      {sessions.map((session, i) =>
        renderSession(`Session ${sessions.length === 1 ? "" : i + 1}`, session)
      )}
      {renderTitledInfo(
        "Allez Go s'engage auprès du Lions Club :",
        <span>
          Le montant versé pour cette réservation:
          {` ${(price * 0.05).toFixed(2)}€`}
          <a
            href="http://lions-rambouillet.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Lions Club de Rambouillet
          </a>
        </span>,
        <a
          href="https://www.lionsclubs.org/fr"
          target="_blank"
          rel="noopener noreferrer"
        >
          {renderHostPic({ name: "", pic: lionsIcon })}
        </a>
      )}
    </Fragment>
  )
}
const renderExtraPics = (pics: string[]) => {
  if (pics.length === 0) {
    return null
  }
  const picsComponent = (
    <div id="picsContainer">
      {pics.map(
        (pic, i) =>
          pic > 0 && (
            <div id="picContainer" key={pic}>
              <img src={pic} alt="thumbnail" />
            </div>
          )
      )}
    </div>
  )
  return renderSection("Photos des voyageurs", picsComponent)
}

const renderSection = (aside: ReactElement | string, content: ReactElement) => {
  const asideContent = typeof aside === "string" ? <h1>{aside}</h1> : aside
  return (
    <Fragment>
      <aside>{asideContent}</aside>
      <div>{content}</div>
    </Fragment>
  )
}

const renderExperience = (experience: Experience) => {
  const {
    type,
    name,
    sessionsNumber,
    typeformLink,
    hostDescription,
    participantsQuotasInfo,
    description,
    price,
    pics,
    sessions,
  } = experience

  function createButton() {
    if (typeformLink) {
      return (
        <a href={typeformLink} target="_blank" rel="noopener noreferrer">
          Réservez
        </a>
      )
    }
    return (
      <Link to={`/events/${name}`} state={{ sessions, name }}>
        Réservez
      </Link>
    )
  }

  const url = window.location.href
  const button = createButton()
  return (
    <Fragment>
      <Navigation animated={false} />
      <div className={styles.experienceContainer}>
        <div>
          {renderSection(
            <Fragment>
              <div id="imageContainer">
                <div>
                  <img src={pics[0]} alt="thumbnail" />
                </div>
                {button}
              </div>
              <div id="shareButtons">
                <InlineShareButtons
                  config={{
                    alignment: "center",
                    color: "social",
                    enabled: true,
                    font_size: 0,
                    labels: "cta",
                    language: "en",
                    networks: [
                      "whatsapp",
                      "linkedin",
                      "messenger",
                      "facebook",
                      "twitter",
                      "instagram",
                      "email",
                    ],
                    padding: 12,
                    radius: 50,
                    show_total: true,
                    size: 40,
                    url,
                  }}
                />
              </div>
            </Fragment>,
            renderDescription(
              sessionsNumber,
              type,
              name,
              hostDescription,
              participantsQuotasInfo,
              description,
              price,
              sessions
            )
          )}
          {pics.length > 1 && renderExtraPics(pics)}
        </div>
      </div>
    </Fragment>
  )
}

const ExperiencePage = (props: RouteComponentProps<IProps>) => {
  const [loading, setLoading] = useState<boolean>(false)

  // const experience = useGetExperienceByName(props.name, setLoading)

  // sendPageTrackingEvent(props.name)

  return loading ? (
    <Spinner />
  ) : (
    <>
      {renderExperience(
        mockedExperiences.find((exp) => exp.name === props.name)
      )}
    </>
  )
}

function useAppsyncSubsciption(handler: (newExperience: Experience) => void) {
  useEffect(() => {
    const subscription = API.graphql(graphqlOperation(onCreateEvent)).subscribe(
      {
        next: handler,
      }
    )

    return () => {
      subscription.unsubscribe()
    }
  })
}

export default ExperiencePage
